/**
 * Parses a JSON string into an object, or returns null for empty/invalid input.
 *
 * Used by admin form pages to convert JSON editor string values into objects
 * before sending them to the API.
 *
 * Returns `null` when:
 * - The value is not a string
 * - The string is empty or whitespace-only
 * - The JSON is invalid
 * - The parsed result is not a plain object (e.g. array, null, number)
 */
export function parseJsonField(value: unknown): Record<string, unknown> | null {
  if (typeof value !== 'string' || value.trim() === '') return null;
  try {
    const parsed: unknown = JSON.parse(value);
    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed))
      return parsed as Record<string, unknown>;
    return null;
  } catch {
    return null;
  }
}
